import { createRequest } from './createRequest'

export const userGetPath = '/user/get'
export const userGet = createRequest({ path: userGetPath })

export const userCreatePath = '/user/create'
export const userCreate = createRequest({ path: userCreatePath })

export const userListPath = '/user/list'
export const userList = createRequest({ path: userListPath })

export const userListPathVerbose= '/user/listVerbose'
export const userListVerbose = createRequest({ path: userListPathVerbose })

export const userEditPath = '/user/edit'
export const userEdit = createRequest({ path: userEditPath })

export const userDeletePath = '/user/delete'
export const userDelete = createRequest({ path: userDeletePath })
